import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { ChevronDown } from "lucide-react";
import React from "react";
import "../../sass/ui/accordion.scss"

const Accordion = AccordionPrimitive.Root;

const AccordionItem = React.forwardRef(({ className = "", ...props }, ref) => (
  <AccordionPrimitive.Item ref={ref} className={`accordion-item ${className}`} {...props} />
));
AccordionItem.displayName = "AccordionItem";

const AccordionTrigger = React.forwardRef(({ className = "", children, ...props }, ref) => (
  <AccordionPrimitive.Header className="accordion-header">
    <AccordionPrimitive.Trigger
      ref={ref}
      className={`accordion-trigger ${className}`}
      {...props}
    >
      {children}
      <ChevronDown className="accordion-icon" />
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
));
AccordionTrigger.displayName = "AccordionTrigger";

const AccordionContent = React.forwardRef(({ className = "", ...props }, ref) => (
  <AccordionPrimitive.Content
    ref={ref}
    className={`accordion-content ${className}`}
    {...props}
  />
));
AccordionContent.displayName = "AccordionContent";

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
